import { Controller } from "@hotwired/stimulus"

// Busca endereço pelo CEP via ViaCEP e preenche os campos do formulário
export default class extends Controller {
  static targets = ["endereco", "bairro"]
  static values  = {
    ufField:        String,
    municipioField: String,
    cidadesUrl:     String
  }

  async buscar(event) {
    const cep = event.target.value.replace(/\D/g, "")
    if (cep.length !== 8) return

    try {
      const res  = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
      const data = await res.json()
      if (data.erro) return

      if (this.hasEnderecoTarget) this.enderecoTarget.value = data.logradouro || ""
      if (this.hasBairroTarget)   this.bairroTarget.value   = data.bairro     || ""

      if (data.uf) {
        this.#setComboboxSilent(this.ufFieldValue, data.uf)

        if (this.cidadesUrlValue && data.localidade) {
          const streamRes = await fetch(`${this.cidadesUrlValue}?selected_uf=${data.uf}`, {
            headers: { "Accept": "text/vnd.turbo-stream.html" }
          })
          const html = await streamRes.text()
          Turbo.renderStreamMessage(html)

          await new Promise(resolve => setTimeout(resolve, 50))
          this.#setComboboxByLabel(this.municipioFieldValue, data.localidade)
        }
      }
    } catch (_e) {
      // falha silenciosa — CEP inválido ou sem conexão
    }
  }

  #setComboboxSilent(name, value) {
    const hidden = document.querySelector(`input[name="${name}"][data-ui--combobox-target="hidden"]`)
    if (!hidden) return
    hidden.value = value
    const wrapper = hidden.closest("[data-controller]")
    if (!wrapper) return
    const visible = wrapper.querySelector("[data-ui--combobox-target='input']")
    if (visible) visible.value = value
  }

  // Selects a combobox option by matching label text, sets hidden input to the option's value (ID)
  #setComboboxByLabel(name, label) {
    const hidden = document.querySelector(`input[name="${name}"][data-ui--combobox-target="hidden"]`)
    if (!hidden) return
    const wrapper = hidden.closest("[data-controller]")
    if (!wrapper) return
    const options = wrapper.querySelectorAll("[data-ui--combobox-target='option']")
    const matching = Array.from(options).find(opt =>
      opt.dataset.label?.toLowerCase() === label.toLowerCase()
    )
    if (!matching) return
    hidden.value = matching.dataset.value
    const visible = wrapper.querySelector("[data-ui--combobox-target='input']")
    if (visible) visible.value = matching.dataset.label
    hidden.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
